var _defs, _sodipodiNamedview, _style;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseTriangle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    sodipodiDocname: "open_triangle.svg",
    inkscapeVersion: "1.1.1 (3bf5ae0d25, 2021-09-20)",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs9"
  })), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview7",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapePageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    showgrid: "false",
    "inkscapeSnap-center": "false",
    "inkscapeSnap-object-midpoints": "false",
    inkscapeZoom: 18.1875,
    inkscapeCx: 23.972509,
    inkscapeCy: 24,
    "inkscapeWindow-width": 2560,
    "inkscapeWindow-height": 1377,
    "inkscapeWindow-x": 1912,
    "inkscapeWindow-y": -8,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "\\u0421\\u043B\\u043E\\u0439_1"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style2"
  }, "\r\n\t.st0{fill:#7B809A;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "g33007",
    transform: "rotate(-89.764956,24.239666,23.129007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g33003"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect32232",
    style: {
      fill: "#7b809a",
      fillRule: "evenodd",
      strokeWidth: 0.76969
    },
    d: "m 29.241717,17.924425 -5.673518,9.936982 -6.07452,-9.882051",
    sodipodiNodetypes: "ccc"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseTriangle);
export default __webpack_public_path__ + "static/media/close_triangle.6e3534922bf05e0d618b929963fad19c.svg";
export { ForwardRef as ReactComponent };